var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4861 10.3247C15.0337 10.3247 17.0988 8.23733 17.0988 5.66237C17.0988 3.08741 15.0337 1 12.4861 1C9.9386 1 7.87341 3.08741 7.87341 5.66237C7.87341 8.23733 9.9386 10.3247 12.4861 10.3247Z",
    stroke: "#1E1A34",
    strokeWidth: 2,
    strokeMiterlimit: 15.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0319 19C23.6371 15.6905 21.0482 13.0705 17.7437 12.6361C15.149 15.5251 10.7035 15.7638 7.81414 13.1691C7.62694 13.0012 7.44904 12.8233 7.28113 12.6361C3.97664 13.0705 1.3877 15.6905 0.99295 19",
    stroke: "#1E1A34",
    strokeWidth: 2,
    strokeMiterlimit: 15.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.02d7d29cbfddf3ea7110f8325d056649.svg";
export { ForwardRef as ReactComponent };